import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateLeadsViews } from '../../../lib/query/invalidateResource';
import { changeLeadStage } from '../api/leads';
import { notification } from 'antd';
import { ApiError } from '../../../lib/api/error';

interface ChangeStagePayload {
  leadId: string;
  toStageId: string;
  expectedVersion?: number;
  closedAmount?: number;
  actualClosingDate?: string;
  closingNote?: string;
  scheduleNext?: boolean;
  nextDueDate?: string;
  nextTitle?: string;
  nextDescription?: string;
  nextPriority?: number;
}

export function useChangeLeadStage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ leadId, ...payload }: ChangeStagePayload) =>
      changeLeadStage(leadId, payload),
    onSuccess: (_, variables) => {
      notification.success({ message: 'Lead stage updated.' });
      invalidateLeadsViews(queryClient);
      void queryClient.invalidateQueries({ queryKey: ['lead', variables.leadId] });
      void queryClient.invalidateQueries({ queryKey: ['taskItems'] });
    },
    onError: (error) => {
      notification.error({ message: ApiError.fromAxiosError(error).message });
    },
  });
}
